import React, { useEffect, useRef, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Features from "./components/Features";
import ScienceBack from "./components/ScienceBack";
import Pricing from "./components/Pricing";
import GuranteeLicence from "./components/GuranteeLicence";
import FAQs from "./components/FAQs";
import PricingCards from "./components/vsl/pricing";
import Gurantee from "./components/vsl/gurantee";
import Bonuses from "./components/vsl/Bonuses";
import Contact from "./components/vsl/Contact";
import Testimonials from "../../components/testomonials";
import FAQ from "./components/vsl/Faq";
import Footer from "./components/Footer";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import WhyOrder from "./components/vsl/whyOrder";
import ClinicalStudies from "../../components/Studies";
import TherapistInfo from "./components/vsl/TherapistInfo";
import arrow from "../../assets/blue-arrow.webp";
import { LOADER_STATUS } from "../../constant/data";

const LandingPage = () => {
  const [isShowVsl, setIsShowVsl] = useState(-1);
  const [isVisible, setIsVisible] = useState(false);
  const [isVideoParamExists, setIsVideoParamExists] = useState(null);
  const location = useLocation();
  const pricingRef = useRef(null);






  const [startTimer, setStartTimer] = useState(false);
  const [isVideoPlay, setIsVideoPlay] = useState(null);

  useEffect(() => {
    if (isShowVsl === -1 && location) {
      setIsShowVsl(0);
      const { search } = location;
      const params = new URLSearchParams(search);
      const hasAnyParam = Array.from(params.entries()).length > 0;
      setIsVideoParamExists(hasAnyParam);

      setIsShowVsl(1);
    }
  }, [location]);







  const maximizeVideo = () => {
    setIsVideoPlay(LOADER_STATUS.PLAY);

    // console.log("Maximize Video", "LOADER", isVideoPlay);
    setIsVideoPlay(LOADER_STATUS.PLAY);
    const video = document.querySelector("#smartplayer");
    const vidwrapper = document.querySelector("#smartplayer > div");
    const vidwrappervid = document.querySelector(
      "#smartplayer > div > div.smartplayer-video-wrap > video"
    );

    video.style.maxWidth = "100%";
    video.style.height = "100vh";
    video.style.padding = "0px";
    video.style.backgroundColor = "#000";

    vidwrapper.style.height = "100vh";
    vidwrapper.style.width = "100%";
    vidwrappervid.style.height = "100vh";
    vidwrappervid.style.width = "100%";
    vidwrappervid.style.objectFit = "contain";

    vidwrappervid.style.transform = "scale(1)";
    vidwrappervid.style.transformOrigin = "top left";

    if (window.innerWidth < 700) {
      vidwrappervid.style.objectFit = "contain";
    }
  };

  const minimizeVideo = () => {
    // console.log("Minimize Video");
    const video = document.querySelector("#smartplayer");
    const vidwrapper = document.querySelector("#smartplayer > div");
    const vidwrappervid = document.querySelector(
      "#smartplayer > div > div.smartplayer-video-wrap > video"
    );

    video.style.padding = "20px";
    video.style.maxWidth = "900px";
    video.style.height = "480px";
    video.style.backgroundColor = "transparent";

    vidwrapper.style.height = "100%";
    vidwrapper.style.width = "100%";

    vidwrappervid.style.height = "100%";
    vidwrappervid.style.width = "100%";
    vidwrappervid.style.objectFit = "cover";

    vidwrappervid.style.transform = "scale(1)";
    vidwrappervid.style.transformOrigin = "top left";

    if (window.innerWidth < 700) {
      vidwrappervid.style.objectFit = "cover";
    }
  };

  useEffect(() => {
    const SECONDS_TO_DISPLAY = 1928;
    let attempts = 0;
    let elsDisplayed = false;

    const alreadyDisplayedKey = `alreadyElsDisplayed${SECONDS_TO_DISPLAY}`;
    const alreadyElsDisplayed = localStorage.getItem(alreadyDisplayedKey);

    const showHiddenElements = () => {
      elsDisplayed = true;
      setIsVisible(true);
      localStorage.setItem(alreadyDisplayedKey, true);

      const player = window.smartplayer.instances?.[0];
      const currentTime = player?.video?.currentTime;
      // console.log(`CTA dropped at Current video time: ${currentTime}`);
    };

    const startWatchVideoProgress = () => {
      if (
        typeof window.smartplayer === "undefined" ||
        !(window.smartplayer.instances && window.smartplayer.instances.length)
      ) {
        if (attempts >= 10) return;
        attempts += 1;
        return setTimeout(() => {
          startWatchVideoProgress();
        }, 1000);
      }
      const player = window.smartplayer.instances[0];
      player.on("timeupdate", () => {
        if (player.smartAutoPlay === false) {
          setIsVideoPlay(LOADER_STATUS.PLAY);
          maximizeVideo();
        }

        if (elsDisplayed || player.smartAutoPlay) return;
        const currentTime = player.video.currentTime;
        // console.log("Current video time:", currentTime);

        if (player.video.currentTime < SECONDS_TO_DISPLAY) return;
        showHiddenElements();
      });

      player.on("pause", () => {
        setIsVideoPlay(LOADER_STATUS.PAUSE);
        minimizeVideo();
      });

      //   player.options.autoplay = false;
      // player.smartAutoPlay = false;
    };

    if (alreadyElsDisplayed === "true") {
      setTimeout(() => {
        showHiddenElements();
      }, 100);
    } else {
      startWatchVideoProgress();
    }
  }, []);

  useEffect(() => {
    if (isVisible && pricingRef.current) {
      pricingRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [isVisible]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 }
    );

    if (pricingRef.current) observer.observe(pricingRef.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (isVisible && !startTimer) {
      setStartTimer(true);
    }
  }, [isVisible, startTimer]);

  const [vid, setVid] = useState("");

  useEffect(() => {
    function replaceVidPlaceholder() {
      if (window?.clickmagick_cmc?.vid) {
        setVid(window.clickmagick_cmc.vid);
      } else {
        setTimeout(replaceVidPlaceholder, 200);
      }
    }
    replaceVidPlaceholder();
  }, []);

  const skipVideoAndShowCTA = () => {
    const video = document.querySelector('video');
    if (video) {
      video.currentTime = 1928;
      video.dispatchEvent(new Event('timeupdate'));
    }
    setIsVisible(true);
  };

  return (
    <>
      <Helmet>
        <link rel="preconnect" href="https://dev.visualwebsiteoptimizer.com" />
        <script type="text/javascript" id="vwoCode">
          {`
            window._vwo_code || (function() {
              var account_id=1072941,
              version=2.1,
              settings_tolerance=2000,
              hide_element='body',
              hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;transition:none !important;';
              /* DO NOT EDIT BELOW THIS LINE */
              var f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};
              try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}
              var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;
              code={
                nonce:v&&v.nonce,
                use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},
                library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},
                settings_tolerance:function(){return cc.sT||settings_tolerance},
                hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},
                hide_element:function(){
                  if(performance.getEntriesByName('first-contentful-paint')[0]){return''}
                  return typeof cc.hE==='string'?cc.hE:hide_element
                },
                getVersion:function(){return version},
                finish:function(e){
                  if(!f){f=true;
                    var t=d.getElementById('_vis_opt_path_hides');
                    if(t)t.parentNode.removeChild(t);
                    if(e)(new Image).src='https://dev.visualwebsiteoptimizer.com/ee.gif?a='+account_id+e
                  }
                },
                finished:function(){return f},
                addScript:function(e){
                  var t=d.createElement('script');
                  t.type='text/javascript';
                  if(e.src){t.src=e.src}else{t.text=e.text}
                  v&&t.setAttribute('nonce',v.nonce);
                  d.getElementsByTagName('head')[0].appendChild(t)
                },
                load:function(e,t){
                  var n=this.getSettings(),i=d.createElement('script'),r=this;
                  t=t||{};
                  if(n){
                    i.textContent=n;
                    d.getElementsByTagName('head')[0].appendChild(i);
                    if(!w.VWO||VWO.caE){
                      stT.removeItem(cK);r.load(e)
                    }
                  }else{
                    var o=new XMLHttpRequest;
                    o.open('GET',e,true);
                    o.withCredentials=!t.dSC;
                    o.responseType=t.responseType||'text';
                    o.onload=function(){
                      if(t.onloadCb){return t.onloadCb(o,e)}
                      if(o.status===200||o.status===304){
                        _vwo_code.addScript({text:o.responseText})
                      }else{
                        _vwo_code.finish('&e=loading_failure:'+e)
                      }
                    };
                    o.onerror=function(){
                      if(t.onerrorCb){return t.onerrorCb(e)}
                      _vwo_code.finish('&e=loading_failure:'+e)
                    };
                    o.send()
                  }
                },
                getSettings:function(){
                  try{
                    var e=stT.getItem(cK);
                    if(!e){return}
                    e=JSON.parse(e);
                    if(Date.now()>e.e){
                      stT.removeItem(cK);return
                    }
                    return e.s
                  }catch(e){return}
                },
                init:function(){
                  if(d.URL.indexOf('__vwo_disable__')>-1)return;
                  var e=this.settings_tolerance();
                  w._vwo_settings_timer=setTimeout(function(){
                    _vwo_code.finish();stT.removeItem(cK)
                  },e);
                  var t;
                  if(this.hide_element()!=='body'){
                    t=d.createElement('style');
                    var n=this.hide_element(),i=n?n+this.hide_element_style():'',r=d.getElementsByTagName('head')[0];
                    t.setAttribute('id','_vis_opt_path_hides');
                    v&&t.setAttribute('nonce',v.nonce);
                    t.setAttribute('type','text/css');
                    if(t.styleSheet)t.styleSheet.cssText=i;
                    else t.appendChild(d.createTextNode(i));
                    r.appendChild(t)
                  }else{
                    t=d.getElementsByTagName('head')[0];
                    var i=d.createElement('div');
                    i.style.cssText='z-index: 2147483647 !important;position: fixed !important;left: 0 !important;top: 0 !important;width: 100% !important;height: 100% !important;background: white !important;display: block !important;';
                    i.setAttribute('id','_vis_opt_path_hides');
                    i.classList.add('_vis_hide_layer');
                    t.parentNode.insertBefore(i,t.nextSibling)
                  }
                  var o=window._vis_opt_url||d.URL,s='https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(o)+'&vn='+version;
                  if(w.location.search.indexOf('_vwo_xhr')!==-1){
                    this.addScript({src:s})
                  }else{
                    this.load(s+'&x=true')
                  }
                }
              };
              w._vwo_code=code;code.init();
            })();
          `}
        </script>
      </Helmet>
      {isVideoParamExists !== null && (
        <div className="w-full">
          {isVideoParamExists ? (
            <>
              {/* vsl page */}
              <div
                className={
                  isVideoPlay === LOADER_STATUS.PLAY
                    ? "w-full"
                    : "max-w-7xl mx-auto"
                }
              >
                {/* Top Block */}
                <div
                  className={
                    isVideoPlay === LOADER_STATUS.PLAY
                      ? "hidden"
                      : "p-3 pt-6 space-y-3 max-w-7xl text-center flex flex-col items-center justify-center"
                  }
                >
                  <h3 className="text-[27px]  text-black font-bold warning">
                    Top US Pulmonologist:
                  </h3>

                  <h3 className="lg:text-4xl lg:leading-[48px] md:text-3xl text-2xl max-w-4xl text-[#dc252c] font-bold ">
                    "This Daily Habit Clears Mucus & Promotes Easy Lung Function"
                    {/* a  */}
                  </h3>
                </div>

                {/* Dynamically embed the player script */}
                <div className="w-full flex items-center justify-center">
                  <div
                    className={
                      isVideoPlay === LOADER_STATUS.PLAY
                        ? "w-full"
                        : "md:w-[70%] w-[90%]"
                    }
                    dangerouslySetInnerHTML={{
                      __html: `<script type="text/javascript" id="scr_67f97d037066994f5ac968ef"></script>`,
                    }}
                  />

                  {/* Helmet to inject the video player script into the head */}
                  <Helmet>

                    <script type="text/javascript" > 
                   {` var s=document.createElement("script");
                     s.src="https://scripts.converteai.net/10a8aace-0f8a-44a8-a764-4b0ebbd85e70/players/67f97d037066994f5ac968ef/player.js";
                      s.async=true;
                      document.head.appendChild(s);`}
                       </script>
                  </Helmet>
                </div>

                <div
                  id="smartplayer"
                  style={{
                    width: "100%",
                    position: "relative",
                    padding: "0",
                  }}
                ></div>

                {/* <div className="text-center mt-10">
                  <button
                    onClick={skipVideoAndShowCTA}
                    className="px-6 py-3 bg-blue-500 text-white rounded-full"
                  >
                    Skip Video and Show CTA
                  </button>
                </div> */}

                <div className="flex items-center justify-center gap-2 mt-14 mb-5 md:mb-0 max-w-7xl mx-auto text-center">
                  <img
                    src="https://cdn1.breatheagain.io/media/vsl/charm_sound.svg"
                    width="28"
                    height="28"
                    className="md:block hidden"
                  />
                  <p className="text-lg sm:text-xl font-semibold leading-6 text-black">
                    <span className="text-red-600 font-bold">IMPORTANT:</span>{" "}
                    Your video may take 10 seconds to load. Make sure your sound
                    is on.
                  </p>
                </div>
              </div>
              {isVisible && (
                <div
                  className="hide smartplayer-scroll-event"
                  id="hidden-section"
                >
                  <div className="md:block hidden ">
                    <div className="max-w-7xl mx-auto my-4 flex items-center justify-center ">
                      <img
                        src="https://cdn.blackincae.com/z8A-blue-arrow.png"
                        className="w-10 h-16"
                      />
                    </div>
                  </div>

                  <div ref={pricingRef}>
                    <PricingCards startTimer={startTimer} />
                  </div>
                  <WhyOrder />
                  <Gurantee />
                  <Bonuses />
                  <Contact />
                  <Testimonials />
                  <PricingCards startTimer={startTimer} />
                  <FAQ />
                </div>
              )}
              <TherapistInfo />
              <ClinicalStudies
                onClickSkip={skipVideoAndShowCTA}
              />
            </>
          ) : (
            <div className="min-h-screen bg-navy-900">
              <Header />
              <Hero />
              <Features />
              <ScienceBack />
              <Pricing />
              <GuranteeLicence />
              <FAQs />
              <Pricing />
              <Footer />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default LandingPage;